import { render, staticRenderFns } from "./replyEmail.vue?vue&type=template&id=5b5155e6"
import script from "./replyEmail.vue?vue&type=script&lang=js"
export * from "./replyEmail.vue?vue&type=script&lang=js"
import style0 from "./replyEmail.vue?vue&type=style&index=0&id=5b5155e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports